<template>
    <section-container title="Combustível" icon="gas-pump">
        <div class="fuel-container">
            <div
                v-for="level in fuelLevels"
                :key="level"
                class="fuel-level"
                :class="{ 'active': combustible === level }"
            >
                <span class="fuel-text">{{ level }}</span>
                <i v-if="combustible === level" class="fas fa-check-circle check-icon"></i>
            </div>
        </div>
    </section-container>
</template>

<script>
import SectionContainer from './SectionContainer.vue';

export default {
    name: "FuelLevelIndicator",
    components: {
        SectionContainer
    },
    props: {
        combustible: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            fuelLevels: ['0', '1/4', '1/2', '3/4', '7/8', 'Cheio']
        };
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Modals/Checklist/FuelLevelIndicator.vue